import React from 'react';
import _ from 'lodash';
import ArticleItem from '../article-item';
import { Spinner } from '../../../etc/spinner';
import styles from './article-list.module.scss';

interface IArticleListProps {
  error: any;
  articles: any[];
  loading: boolean;
  meta: object;
  forMyCourses: boolean;

  fetchArticles(offset?: number, url?: string): Promise<any>;
}

export default class ArticleList extends React.Component<IArticleListProps> {
  public scrollListener = _.throttle(() => {
    const { loading, meta, articles, forMyCourses } = this.props;
    // does not detect if loading or loaded all articles
    if (forMyCourses || loading || _.get(meta, 'count') <= articles.length) return;

    // detect if reached bottom of page
    const { documentElement: page } = document;
    if ( window.innerHeight + page.scrollTop >= Math.min(page.offsetHeight * 0.8, page.offsetHeight - window.innerHeight)) {
      this.props.fetchArticles(articles.length);
    }
  }, 1000);

  public componentDidMount() {
    const { loading, meta, articles, forMyCourses } = this.props;
    if (forMyCourses || !loading || (!loading && _.get(meta, 'count') > articles.length)) {
      this.props.fetchArticles(0);
    }

    // Adds scroll listener for progressives loading
    window.addEventListener('scroll', this.scrollListener);
  }

  public componentWillUnmount() {
    // removes scroll listener for progressive loading
    window.removeEventListener('scroll', this.scrollListener);
  }

  public renderLoading = () => {
    return this.props.loading ? <div style={{padding: '1em', textAlign: 'center'}}><Spinner loading={this.props.loading}>Loading...</Spinner></div> : null;
  }

  public renderArticles = () => {
    // TODO: Need to optimize this code for large number of articles.

    return this.props.articles ? this.props.articles.map(article => <ArticleItem key={article.id} {...article} />) : <p>There are no articles in this list.</p>
  }

  public render() {
    const { loading, meta, articles } = this.props;

    return (
      <div>
        {this.renderArticles()}
        {this.renderLoading()}
        {/*Button to load more articles. Saved if we ever need it.*/}
        {/*loading || meta.count <= articles.length ? null : <div className={`${styles.bottomBar} ${styles.loadMore}`} onClick={()=>this.propsfetchArticles(articles.length)}>Load More!</div>*/}
        {loading || _.get(meta, 'count') > articles.length ? null: <div className={styles.bottomBar}>There are no more articles to load.</div>}
      </div>
    );
  }
}
